import { render, staticRenderFns } from "./VigilanceOptions.vue?vue&type=template&id=15588700"
import script from "./VigilanceOptions.vue?vue&type=script&lang=js"
export * from "./VigilanceOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports